<mat-card appearance="outlined" color="black">
    <mat-card-content>
        <a (click)="router.navigate([menuItem.href])">
        <div>
            <mat-icon class="menu-card-ico">{{menuItem.matIcon}}</mat-icon>
            <div class="label">
                <p class="text-center">{{ menuItem.label }}</p>
            </div>
        </div>
        </a>
    </mat-card-content>
</mat-card>